'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useQueryClient } from '@tanstack/react-query'

import { clearQueryClientAuthStateBestEffort } from '@/services/auth/queryClientCleanup.client'
import { subscribeToImpersonationSync } from '@/services/auth/impersonationSync.client'

export default function ImpersonationSyncListener() {
  const queryClient = useQueryClient()
  const router = useRouter()

  useEffect(() => {
    return subscribeToImpersonationSync(() => {
      void (async () => {
        await clearQueryClientAuthStateBestEffort(queryClient)
        router.refresh()
      })()
    })
  }, [queryClient, router])

  return null
}
